import { Link } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { useLanguage, exitPreview } from "../i18n/LanguageContext";

export const PreviewBanner = () => {
  const { preview } = useLanguage();
  if (!preview) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-[#B85D2A] text-white" data-testid="preview-banner">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-12 flex items-center justify-between gap-4">
        <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em]">
          <Eye size={14} /> Preview Mode — viewing draft content
        </p>
        <div className="flex items-center gap-3">
          <Link to="/admin" className="font-mono text-[11px] uppercase tracking-[0.15em] underline underline-offset-4 hover:no-underline" data-testid="preview-back-admin">
            Back to Admin
          </Link>
          <button onClick={exitPreview} data-testid="preview-exit-button" className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#142D44] font-mono text-[11px] uppercase tracking-[0.15em] hover:bg-black transition-colors">
            <X size={12} /> Exit Preview
          </button>
        </div>
      </div>
    </div>
  );
};
